module.exports = __webpack_public_path__ + "img/beer_id-63.fa948b47.png";